import { converterDataHoraBr } from "_utils/Data";
import { StatusBadge } from "components/StatusBadge";
import { useAbrirProcesso } from "features/core/pages/Financeiro/Pages/PagamentoTaxa/CriarLote/hooks/useAbrirProcesso";
import {
  IColunaTabelaPadrao,
  TabelaPadrao,
} from "../../../../components/TabelaPadrao";
import { ORDENACAO_ITENS_LOTE_PADRAO } from "../../../../constants/filtrosItensLote";
import {
  chaveStatusAutorizacaoItem,
  chaveStatusProducaoItem,
  labelStatus,
  varianteStatus,
} from "../../../../constants/status";
import { LinkProcesso } from "../../../../containers/Listar/style";
import { IItemLote } from "../../../../interfaces/IItemLote";
import { DirecaoOrdenacao } from "../../../../interfaces/IOrdenacao";
import { rotuloPrensa } from "../../../../utils/rotulosLote";

const SEM_VALOR = "—";

function badgeStatus(chave: string) {
  return (
    <StatusBadge label={labelStatus(chave)} variant={varianteStatus(chave)} />
  );
}

interface IProps {
  itens: IItemLote[];
  totalRegistros: number;
  carregando: boolean;
  limite: number;
  reiniciarPaginacao: boolean;
  limparSelecao: number;
  onMudarPagina: (pagina: number) => void;
  onMudarLimite: (limite: number) => void;
  onOrdenar: (campo: string, direcao: DirecaoOrdenacao) => void;
  onExportar: () => void;
  exportando: boolean;
  setSelecionados: (itens: IItemLote[]) => void;
}

export function Listar({
  itens,
  totalRegistros,
  carregando,
  limite,
  reiniciarPaginacao,
  limparSelecao,
  onMudarPagina,
  onMudarLimite,
  onOrdenar,
  onExportar,
  exportando,
  setSelecionados,
}: IProps) {
  const { redirecionarProcesso } = useAbrirProcesso();

  const colunas: IColunaTabelaPadrao<IItemLote>[] = [
    {
      chave: "dataSolicitacao",
      titulo: "Solicitação",
      selector: ({ dataSolicitacao }) =>
        converterDataHoraBr(dataSolicitacao) ?? SEM_VALOR,
      sortable: true,
      sortField: "dataSolicitacao",
      width: "190px",
    },
    {
      chave: "pdi",
      titulo: "PDI",
      selector: ({ pdi }) => pdi ?? SEM_VALOR,
      sortable: true,
      sortField: "pdi",
      width: "150px",
    },
    {
      chave: "prensa",
      titulo: "Prensa",
      selector: ({ prensa }) =>
        prensa === null ? SEM_VALOR : rotuloPrensa(prensa),
      sortable: true,
      sortField: "prensa",
    },
    {
      chave: "empresa",
      titulo: "Empresa",
      selector: ({ empresa }) => empresa ?? SEM_VALOR,
      sortable: true,
      sortField: "empresa",
    },
    {
      chave: "placa",
      titulo: "Placa",
      selector: ({ placa }) => placa,
      sortable: true,
      sortField: "placa",
      width: "110px",
    },
    {
      chave: "processo",
      titulo: "Processo",
      selector: ({ idProcesso }) => idProcesso ?? SEM_VALOR,
      cell: ({ idProcesso }) =>
        idProcesso ? (
          <LinkProcesso
            type="button"
            onClick={() => redirecionarProcesso(idProcesso)}
          >
            {idProcesso}
          </LinkProcesso>
        ) : (
          SEM_VALOR
        ),
      sortable: true,
      sortField: "idProcesso",
      width: "120px",
    },
    {
      chave: "autorizacao",
      titulo: "Autorização",
      selector: ({ idAutorizacao }) => idAutorizacao ?? SEM_VALOR,
      sortable: true,
      sortField: "idAutorizacao",
    },
    {
      chave: "statusAutorizacao",
      titulo: "Status autorização",
      selector: ({ statusAutorizacao }) => statusAutorizacao,
      cell: ({ statusAutorizacao }) =>
        badgeStatus(chaveStatusAutorizacaoItem(statusAutorizacao)),
      sortable: true,
      sortField: "statusAutorizacao",
      width: "170px",
    },
    {
      chave: "statusProducao",
      titulo: "Status produção",
      selector: ({ statusProducao }) => statusProducao,
      cell: ({ statusProducao }) =>
        statusProducao === null
          ? SEM_VALOR
          : badgeStatus(chaveStatusProducaoItem(statusProducao)),
      sortable: true,
      sortField: "statusProducao",
      width: "160px",
    },
    {
      chave: "observacao",
      titulo: "Observação",
      selector: ({ observacao }) => observacao ?? SEM_VALOR,
      minWidth: "320px",
    },
  ];

  return (
    <TabelaPadrao
      titulo="Detalhes do lote"
      chaveConfigColunas="solicitacaoPlaca:itensLote:colunas"
      limitarALargura
      colunas={colunas}
      dados={itens}
      carregando={carregando}
      totalRegistros={totalRegistros}
      limite={limite}
      colunaOrdenadaInicial={ORDENACAO_ITENS_LOTE_PADRAO.campo}
      reiniciarPaginacao={reiniciarPaginacao}
      limparSelecao={limparSelecao}
      onMudarPagina={onMudarPagina}
      onMudarLimite={onMudarLimite}
      onOrdenar={onOrdenar}
      onExportar={onExportar}
      exportando={exportando}
      selecionavel
      onSelecionar={setSelecionados}
    />
  );
}
